import * as React from 'react'
import { FluidObject } from 'gatsby-image'
import Image from 'gatsby-image/withIEPolyfill'
import TextBlock from './common/TextBlock'
import SubSection from './common/SubSection'
import styled from 'styled-components'
import { constants, FontSettings } from '../constants'
import SectionTitle from './common/SectionTitle'
import { renderWithNewlines } from '../render-utils'
import { FontsContext } from '../context'

interface Props {
  title: string
  text: string
  subtitle: string
  blocks: any[]
  footnote: string
  sideImage: FluidObject
  imageAlt?: string
}

const PackagingDevelopment = ({
  title,
  text,
  subtitle,
  blocks,
  footnote,
  sideImage,
  imageAlt,
}: Props) => {
  const fonts = React.useContext(FontsContext)

  return (
    <SubSection>
      <SectionTitle fonts={fonts} settings={fonts.texts.title3}>
        {title}
      </SectionTitle>
      <Wrapper>
        <StyledTextBlock>
          <BlockWithMargin>{renderWithNewlines(text)}</BlockWithMargin>
          <BoldText fonts={fonts}>{subtitle}</BoldText>
          <BlockWithMargin>
            {blocks.map(block => (
              <div key={block.title}>
                <BoldText fonts={fonts}>{block.title}</BoldText>
                <div>{block.text}</div>
              </div>
            ))}
          </BlockWithMargin>
          <div>{footnote}</div>
        </StyledTextBlock>
        <ImageWrapper>
          <Image fluid={sideImage} alt={imageAlt} />
        </ImageWrapper>
      </Wrapper>
    </SubSection>
  )
}

const BoldText = styled.div<{ fonts: FontSettings }>(
  props => `
  font-family: ${props.fonts.boldFontFamily};
  font-weight: bold;
`
)

const BlockWithMargin = styled.div`
  margin-bottom: ${constants.spacing.sp.medium};

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    margin-bottom: ${constants.spacing.small};
  }
`

const Wrapper = styled.div`
  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    display: flex;
  }
`

const StyledTextBlock = styled.div`
  margin-bottom: ${constants.spacing.sp.medium};
  font-size: ${constants.font.size.sp.medium};
  color: ${constants.colors.text.dark};
  line-height: 1.8;
  letter-spacing: 0.47px;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    font-size: ${constants.font.size.medium};
    letter-spacing: 0.57px;
    line-height: 2;
    order: 2;
    margin-bottom: 0;
  }
`

const ImageWrapper = styled.div`
  margin: 0 ${constants.spacing.sp.medium};

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    margin: 0;
    order: 1;
    flex: 0 0 239px;
    padding-right: 16px;
  }
`

export default PackagingDevelopment
